export default __webpack_public_path__ + "static/create-new-action-dark-mode-0b9d6aeabd275023790fb0ef7dc2c2ec.png";